import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Controller } from 'react-hook-form';
import EmailCheck from '../../../../../styledComponents/styles/EmailCheck.styled';
import { NavLink } from 'react-router-dom';
import ScreenReaderHeadingComponent from '../../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';

const Action = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  a {
    color: #373737;
    font-weight: 600;
    text-decoration: underline;
  }
`;

const EmailLookup = styled.div`
  padding: 23px 0 37px 0;
  text-align: left;
`;

const Header = styled.span`
  color: #0b3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;

  span {
    font-weight: 600;
  }
`;

// Step 1.
export default function LookupStep(props) {
  let { control, errors, setValue, getValues, isValid, nextStep } = props;
  const [emailCheck, setEmailCheck] = useState();
  const [errorText, setErrorText] = useState('');

  useEffect(
    () => {
      if (emailCheck) {
        setValue('email', '');
        setValue('password', '');
        setValue('passwordConfirm', '');

        if (
          emailCheck &&
          !emailCheck.loading &&
          (!emailCheck.data || emailCheck?.data?.client_account?.subdomain === 'ccfc')
        ) {
          setValue('email', emailCheck.searchedEmail);
          nextStep(2);
        } else {
          setErrorText('Unable to create account');
        }
      }
    },
    [emailCheck],
  );

  return (
    <>
      <ScreenReaderHeadingComponent text={"Create your account screen reader"} />
      <Header>Create your account</Header>
      <Instructions>Enter your email to get started</Instructions>
      <Controller
        control={control}
        name={'email'}
        render={({ field: { ref, ...rest } }) => (
          <EmailLookup>
            <EmailCheck
              buttonText={'Next'}
              customErrorMsg={errorText}
              id={'email'}
              onClick={value => setEmailCheck(value)}
              placeholder={'Enter your email'}
              label={'Enter your email'}
              required={true}
            />
          </EmailLookup>
        )}
      />
      <Action>
        Already have an account? <NavLink to="/">Sign in</NavLink>
      </Action>
    </>
  );
}
